module.exports = __webpack_public_path__ + "img/logo-acm.560dcc62.png";